import { create } from "zustand";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config"; // adjust if your firebase config lives elsewhere
import { getCardImageByName } from "../utils/Utils";
import { infinityCards as cards } from "../game/infinityCards";

export const useCardStore = create((set) => ({
  infinityCards: [],
  characterCards: [],
  isLoading: false,
  error: null,

  fetchCards: async () => {
    try {
      set({ isLoading: true });

      const [infinitySnap, characterSnap] = await Promise.all([
        getDocs(collection(db, "Infinity cards")),
        getDocs(collection(db, "Character cards")),
      ]);

      const infinityCards = infinitySnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const characterCards = characterSnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((card) => !!card.ipProviderStripeId);

      //   const infinityCards = cards.map((data) => {
      //     return {
      //       ...data,
      //       image: getCardImageByName(data.name),
      //     };
      //   });

      set({
        infinityCards,
        characterCards,
        isLoading: false,
        error: null,
      });
    } catch (err) {
      console.error("Error fetching cards:", err);
      set({ error: err.message, isLoading: false });
    }
  },
}));
